import { outlookTypes } from 'shared/constants/outlookTypes';

export const getScoreWidgetFooterColor = outlook => {
  const outlookToScoreWidgetFooterColorMap = {
    [outlookTypes.NONE]: 'white',
    [outlookTypes.STABLE]: 'white',
    [outlookTypes.NEGATIVE]: 'red',
    [outlookTypes.POSITIVE]: 'green',
  };

  return outlookToScoreWidgetFooterColorMap[outlook] || 'white';
};
